import React from 'react';

import { SelectControlOption } from 'types/state';
import { useCountriesValues } from 'hooks/useCountriesValues';
import { SelectControlComponent, SelectOptionComponent } from 'design/select';

type Props = {
  name: string;
  value: null | string;
  invalid: boolean;
  onChange(nextValue: string): void;
};

export const CountryInputComponent = (props: Props) => {
  const { value, invalid, name, onChange } = props;

  const { primaryCountries, secondaryCountries } = useCountriesValues();

  const primaryOptions = React.useMemo(() => {
    const options: SelectControlOption<string>[] = [];

    primaryCountries.forEach(([code, name]) => {
      options.push({
        value: code,
        title: name,
      });
    });

    return options;
  }, [primaryCountries]);

  const secondaryOptions = React.useMemo(() => {
    const options: SelectControlOption<string>[] = [];

    secondaryCountries.forEach(([code, name]) => {
      options.push({
        value: code,
        title: name,
      });
    });

    return options;
  }, [secondaryCountries]);

  return (
    <SelectControlComponent
      name={name}
      invalid={invalid}
      value={`${value}`}
      onValueChange={onChange}
    >
      <SelectOptionComponent disabled value="null">
        {''}
      </SelectOptionComponent>
      {primaryOptions.map((option) => (
        <SelectOptionComponent key={option.value} value={option.value}>
          {option.title}
        </SelectOptionComponent>
      ))}
      <SelectOptionComponent disabled value="">
        {'------'}
      </SelectOptionComponent>
      {secondaryOptions.map((option) => (
        <SelectOptionComponent key={option.value} value={option.value}>
          {option.title}
        </SelectOptionComponent>
      ))}
    </SelectControlComponent>
  );
};
